import { AnimatedGLBVisual } from "./AnimatedGLBVisual";
export class HumanVisual extends AnimatedGLBVisual {

  public getType(): string {
    return 'HumanVisual';
  }
  
}